<template>
  <v-row align="stretch">
    <v-col cols="12" md="6">
      <change-password />
    </v-col>
    <v-col cols="12" md="6">
      <two-factor-auth />
    </v-col>
    <v-col v-if="is2FAEnabled" cols="12">
      <change-security-questions />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangePassword from '@/components/Profile/Security/ChangePasswordCard'
import ChangeSecurityQuestions from 'Components/Profile/Security/SecurityQuestions/ChangeSecurityQuestions'
import TwoFactorAuth from 'Components/Profile/Security/TwoFactorAuth/TwoFactorAuth'
// import SecurityCode from '@/components/Profile/SecuritySecurityCode'

export default {
  name: 'ProfileSecurity',
  components: {
    ChangePassword,
    ChangeSecurityQuestions,
    TwoFactorAuth,
    // SecurityCode,
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    is2FAEnabled () {
      return !!this.SessionProfile.totp_enabled
    }
  },
}
</script>
